/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import { NDC_TABS_DATA } from '../../../System/TechnicalWindow/OnlineFixes/RequestedPreviousClaim/utils/constant';
import { setNDCSelectedNDCTab } from '../../NDC/store/action';

const CalculatedInterestRadioGroup = ({}) => {
  const dispatch = useDispatch();
  const selectedNDCTab = useSelector(
    (state) => state.sharedState.ndc.selectedNDCTab
  );
  const onNDCTypeChange = (type) => {
    dispatch(setNDCSelectedNDCTab(type));
  };

  return (
    <>
      <div className="mui-custom-form col-12 m-0 p-0">
        <RadioGroupComponent
          labelName="Search Type"
          required
          reqColor
          id="ndcSearchTypeType"
          data-testid="ndcSearchTypeType"
          optionList={NDC_TABS_DATA}
          defaultValue={selectedNDCTab}
          filterAction={onNDCTypeChange}
        />
      </div>
    </>
  );
};
export default CalculatedInterestRadioGroup;
